/** Shared column definitions — single source of truth for header ↔ row alignment */

/**
 * The five data columns (first name, last name, username, class, grade) share
 * the same fluid width; minmax(0, 1fr) lets them shrink below their
 * min-content so the row always fits the drawer/modal width (AR-809).
 */
const DATA_COLUMNS = 'repeat(5, minmax(0, 1fr))'

/** Grid template for rows WITH remove button */
export const GRID_TEMPLATE = `${DATA_COLUMNS} 36px`

/** Grid template for rows WITHOUT remove button */
export const GRID_TEMPLATE_NO_REMOVE = DATA_COLUMNS

export const GRID_GAP = 8
